import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MomentModule } from '@fredjohnd/ngx-moment';

import { StepCardStatusLabelEnum } from '@shared/components/approval-workflow-steps/enum/step-card-status-label.enum';
import { StepCardViewData } from '@shared/components/approval-workflow-steps/models/step-card.model';
import { ApprovalStatusEnum } from '@shared/components/generate-approval-workflow/enum/generate-approval-workflow.enum';
import { ApproverModel } from '@shared/components/generate-approval-workflow/model/generate-approval-workflow.model';
import { PipesModule } from '@shared/pipes/pipes.module';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-step-card',
  standalone: true,
  imports: [CommonModule, MomentModule, PipesModule, SharedModule],
  templateUrl: './step-card.component.html',
  styleUrls: ['./step-card.component.scss']
})
export class StepCardComponent {
  @Input() card!: StepCardViewData;

  readonly ApprovalStatusEnum = ApprovalStatusEnum;

  get isApprovedOrRejected(): boolean {
    return [ApprovalStatusEnum.APPROVED, ApprovalStatusEnum.REJECTED, ApprovalStatusEnum.AWAITING].includes(
      this.card?.status
    );
  }

  get statusText(): string {
    if (this.card?.autoApprove && this.card?.status === ApprovalStatusEnum.APPROVED) {
      return StepCardStatusLabelEnum.AUTO_APPROVED;
    }
    return StepCardStatusLabelEnum[this.card.status] || this.card.status;
  }

  approverName(approver: ApproverModel): string {
    return `${approver.firstName || ''} ${approver.lastName || ''}`.trim();
  }

  isApproverActive(approver: ApproverModel): boolean {
    if ([ApprovalStatusEnum.ON_QUEUED, ApprovalStatusEnum.CANCELLED].includes(this.card?.status)) {
      return false;
    }
    const hasAnyAction = (this.card?.approvers || []).some(app => app.approve !== null);
    if (hasAnyAction) {
      return approver.approve !== null;
    }
    return true;
  }
}
